import { useQuery } from '@tanstack/react-query';
import { useField } from 'formik';
import { FormikSelectField, FormikSelectFieldProps } from 'formik-ui';
import React from 'react';
import { fetchSubregions } from '~/api/address';

interface Props extends FormikSelectFieldProps {
  countryFieldName: string;
}

const FormikDynamicStateSelect: React.FC<Props> = ({
  countryFieldName,
  ...props
}) => {
  const [country] = useField(countryFieldName);

  const { data: subregions } = useQuery(['regions', country.value], () =>
    fetchSubregions(country.value),
  );

  return (
    <FormikSelectField {...props}>
      <option value="" disabled>
        Select a state
      </option>

      {subregions?.map(subregion => (
        <option key={subregion.id} value={subregion.id}>
          {subregion.name}
        </option>
      ))}
    </FormikSelectField>
  );
};

export default FormikDynamicStateSelect;
